<template>
    <component
        v-bind="bind"
        :class="bem('sidebar-link', { active, validation})"
    >
        <div class="sidebar-link__text">
            <slot/>
        </div>
        <div class="sidebar-link__icon" />
    </component>
</template>

<script>
    export default {
        props: {
            active: Boolean,
            to: String,
            href: String,
            validation: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            bind(){
                if(this.to){
                    return{
                        is: 'router-link',
                        to: this.to,
                    }
                } else if(this.href){
                    return {
                        is: 'a',
                        target: '_blank',
                        href: this.href,
                    }
                } else {
                    return {
                        is: 'div',
                    }
                }
            },
        },
    }
</script>

<style src="./sidebar-link.less" lang="less"></style>